import { all, call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestNapi } from '@wix/da-http-client';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';
import { normalizeDeviation } from '@wix/da-shared-react/pkg/redux/normalizr/helpers';
import { updateDeviationTitle } from '../../actions/studio';

function* updateDeviationEntityTitle(deviation, title) {
  const updatedDeviation = {
    ...deviation,
    title: title,
  };
  const entities = normalizeDeviation(updatedDeviation);
  yield put(putEntities({ entities }));
}

function* handleUpdateDeviationTitle({
  payload: { deviation, title },
}: ReturnType<typeof updateDeviationTitle>) {
  const previousTitle = deviation.title;

  // update deviation title preemptively so that the ux is smoother and we avoid loaders
  yield call(updateDeviationEntityTitle, deviation, title);

  const response = yield call(requestNapi, {
    method: 'post',
    url: deviation.isJournal ? '/journal/update/content' : '/deviation/update',
    data: { deviationid: deviation.deviationId, title },
  });

  if (!response || isApiError(response)) {
    // if anything fails, return deviation title to previous value
    yield call(updateDeviationEntityTitle, deviation, previousTitle);
  }
}

export default function* saga() {
  yield all([takeEvery(updateDeviationTitle, handleUpdateDeviationTitle)]);
}
